import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=36ef0bdb&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=36ef0bdb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef0bdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ef0bdb')) {
      api.createRecord('36ef0bdb', component.options)
    } else {
      api.reload('36ef0bdb', component.options)
    }
    module.hot.accept("./AdditionalInfo.vue?vue&type=template&id=36ef0bdb&scoped=true", function () {
      api.rerender('36ef0bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/AdditionalInfo.vue"
export default component.exports